"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.paymentMethod = exports.cardType = exports.cardStatus = exports.label = exports.cardExpiry = void 0;

var _react = require("@emotion/react");

var _legacy = require("../../../components/legacy");

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  border: solid 1px ", ";\n  border-radius: 5px;\n  padding: 12px 12px 12px 16px;\n  background-color: ", ";\n  color: inherit;\n  font-size: inherit;\n  line-height: inherit;\n  cursor: ", ";\n\n  &:disabled {\n    cursor: default;\n  }\n\n  &:focus {\n    outline: none;\n  }\n\n  &:hover #label {\n    display: block;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  flex-shrink: 0;\n  margin: 0 16px 0 0;\n  opacity: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n\n  &::before {\n    content: '\\2022';\n    margin: 0 2px;\n    color: ", ";\n  }\n"], ["\n  color: ", ";\n\n  &::before {\n    content: '\\\\2022';\n    margin: 0 2px;\n    color: ", ";\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: ", ";\n  flex: 1;\n  text-align: right;\n  color: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  color: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var cardExpiry = function cardExpiry(_ref) {
  var colors = _ref.colors;
  return (0, _react.css)(_templateObject(), colors.neutral[500]);
};

exports.cardExpiry = cardExpiry;

var label = function label(selected) {
  return function (_ref2) {
    var colors = _ref2.colors;
    return (0, _react.css)(_templateObject2(), selected ? 'transparent' : 'none', colors.neutral[400]);
  };
};

exports.label = label;

var cardStatus = function cardStatus(expired) {
  return function (_ref3) {
    var colors = _ref3.colors;
    return (0, _react.css)(_templateObject3(), expired ? colors.danger : 'inherit', colors.neutral[500]);
  };
};

exports.cardStatus = cardStatus;

var cardType = function cardType(expired) {
  return function () {
    return (0, _react.css)(_templateObject4(), expired ? 0.5 : 1);
  };
};

exports.cardType = cardType;

var paymentMethod = function paymentMethod(selected, isButton) {
  return function (_ref4) {
    var colors = _ref4.colors;
    return (0, _react.css)(_templateObject5(), selected ? colors.accent : 'transparent', selected ? (0, _legacy.hexRgb)(colors.accent, 0.05) : colors.neutral[0], isButton ? 'pointer' : undefined);
  };
};

exports.paymentMethod = paymentMethod;